<template>
    <div class="FullObject">
        <div class="FullObject__header-info show-mobile">
            <div class="FullObject__id">ID {{id}}</div>
            <div class="FullObject__name">{{name}}</div>
            <div class="FullObject__location">
                {{location}}
            </div>
        </div>
        <div class="FullObject__images">
            <ImageSlider v-if="images_object.length" :show-pagination="false" :show-navigation="images_object.length > 1" :images="images_object" @open="$emit('open', $event)"/>
            <ImageSlider v-else-if="images.length" :show-pagination="false" :show-navigation="images.length > 1" :images="images" @open="$emit('open', $event)"/>
            <NoImages v-else></NoImages>
        </div>
        <div class="FullObject__header">
            <div class="FullObject__header-info hide-mobile">
                <div class="FullObject__id">ID {{id}}</div>
                <div class="FullObject__name">{{name}}</div>
                <div class="FullObject__location">
                    {{location}}
                </div>
            </div>
            <div class="FullObject__price">
                <ObjectPrice v-bind="price" :tp="tp" :full-price="true"/>
            </div>
        </div>
        <div class="FullObject__about-block">
            <div class="FullObject__params">
                <div class="hide-mobile">
                    <FullObjectParams :params="params"/>
                </div>
                <div class="show-mobile">
                    <ObjectParams :params="params"/>
                </div>
            </div>
            <div class="FullObject__actions">
                <div class="FullObject__like-buttons">
                    <ObjectLikeButtons :status="likeStatus" :id="id"/>
                </div>
                <ObjectAppointment :id="id"/>
            </div>
        </div>
        <h3 class="section-title">Описание объекта</h3>
        <div class="FullObject__description-block">
            <div class="FullObject__description-params">
                <ObjectDescriptionParams/>
            </div>
            <div class="FullObject__description-block-body">
                <div class="FullObject__description-text-block">
                    <div class="FullObject__description-text">
                        {{ descr }}
                    </div>

                    <div class="FullObject__item" v-for="({title, value}, index) of items" :key="index">
                        <div class="FullObject__description-text-title">{{title}}</div>
                        <div class="FullObject__description-text">{{value}}</div>
                    </div>

                    <div class="FullObject__video-button">
                        <Button :transparent="true" v-if="video"><a :href="video" target="_blank">Видеопрезентация</a></Button>
                    </div>
                </div>
                <div class="FullObject__description-images" v-if="file_plan">
                    <ImageSlider :show-pagination="false" :show-navigation="true" :images="file_plan" @open="$emit('open', $event)"/>
                </div>
            </div>
        </div>
        <div class="section-title" v-if="comment">Комментарий брокера</div>
        <div class="FullObject__comment-block" v-if="comment">
            <div class="FullObject__comment-block-about">
                <div class="FullObject__comment-person">
                    <div class="FullObject__comment-person-name">
                        {{ broker.name }}
                    </div>
                    <div class="FullObject__comment-position">
                        {{ broker.position }}
                    </div>
                </div>
                <img src="@/assets/image/icons/quotes.png" class="FullObject__comment-quotes" alt="">
            </div>
            <div class="FullObject__comment-text">
                {{ comment }}
            </div>
        </div>
        <!--<Modal class="image-modal-full" :open="imageOpened" @close="imageOpened = false" >
            <img  v-for="item in imageOpened" :src="item" :key="item">
        </Modal>-->
    </div>
</template>

<script>
import ObjectPrice from '@/components/Object/ObjectPrice';
import FullObjectParams from "@/components/Object/FullObjectParams";
import ObjectLikeButtons from "@/components/Object/ObjectLikeButtons";
import ObjectAppointment from "@/components/Object/ObjectAppointment";
import ObjectDescriptionParams from "@/components/Object/ObjectDescriptionParams";
import ImageSlider from "@/components/Object/ImageSlider";
import Button from "@/components/elements/Button";
import ObjectParams from "@/components/Object/ObjectParams";
import NoImages from "@/components/elements/NoImages";

export default {
    name: "FullObject",
    inheritAttrs: false,
    components: {
        ObjectPrice,
        FullObjectParams,
        ObjectLikeButtons,
        ObjectAppointment,
        ObjectDescriptionParams,
        ImageSlider,
        Button,
        ObjectParams,
        NoImages
    },
    props: {
        id: [Number, String],
        name: String,
        location: String,
        price: {
            current: [Number, String],
            prev: [Number, String]
        },
        params: Object,
        likeStatus: Number,
        images: Array,
        images_object: Array,
        comment: String,
        descr: String,
        video: String,
        tp: Number
    },
    computed: {
        broker() {
            return this.$store.state.broker;
        },
        items() {
            let obj = this.$store.state.objects.filter(object => object.id === this.$route.params.id);
            return obj[0].full_params.levels;
        },
        file_plan() {
            let obj = this.$store.state.objects.filter(object => object.id === this.$route.params.id);
            if (obj[0].file_plan.length) {
                return obj[0].file_plan;
            } else {
                return false;
            }
        }
    },
    mounted() {
        setTimeout( function() {
            document.querySelector('.FullObject__images').scrollIntoView({block: "center", behavior: "smooth"});
        }, 100);

    }
}
</script>

<style lang="scss">
    .FullObject__description-images .ImageSlider__image {
        background-size: contain !important;
        background-repeat: no-repeat;
    }

.FullObject {
  padding: 22px 20px 40px;
  border-radius: 16px;
  background-color: $white;

    .image-modal-full .Modal__content {
        text-align: center;
        max-width: 90%;
        max-height: 85%;
        height: 100%;
        padding: 10px 0;
        background: white;
        overflow-scrolling: auto;

        svg {
            background: rgba(0, 0, 0, 0.5);
            border-radius: 50%;

            path {
                fill: $white;
            }
        }

        img {
            max-width: 100%;
            max-height: 90vh;
            //height: 90%;
            display: inline-block;
            padding: 10px;
        }
    }

  @include mobile {
    border-radius: 0;
    padding: 16px 16px 40px;
  }

  &__images {
    height: 550px;
    margin-bottom: 32px;
    border-radius: 16px;
    overflow: hidden;
    max-height: 65vh;

    @include tablet {
      margin-bottom: 24px;
    }

    @include mobile {
      height: 190px;
      margin-bottom: 14px;
    }
  }

  &__id {
    font-size: 12px;
    margin-bottom: 8px;
  }

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 24px;

    @include mobile {
      margin-bottom: 14px;
    }
  }

  &__header-info {

    @include mobile {
      margin-bottom: 16px;
    }
  }

  &__name {
    font-size: 26px;
    font-weight: 500;
    padding-right: 12px;
    margin-bottom: 8px;

    @include tablet {
      font-size: 20px;
    }
  }

  &__price {

    .ObjectPrice__main-value {
      font-size: 34px;

      @include tablet {
        font-size: 20px;
      }
    }
  }

  &__location {
    font-size: 16px;
  }

  &__about-block {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 60px;

    @include tablet {
      flex-direction: column;
      align-items: flex-end;
      margin-bottom: 40px;
    }
  }

  &__params {
    padding-right: 125px;

    @include tablet {
      width: 100%;
      padding-right: 0;
      margin-bottom: 32px;
    }

    @include mobile {
      margin-bottom: 16px;
    }
  }

  &__actions {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    @include tablet {
      width: 100%;
    }
  }

  &__like-buttons {
    margin-bottom: 30px;

    @include tablet {
      margin-bottom: 24px;
      display: flex;
      justify-content: flex-end;
    }

    @include mobile {
      justify-content: center;

      .ObjectLikeButtons {
        width: 100%;
      }
    }
  }

  &__description-block {
    margin-top: 40px;
    margin-bottom: 60px;

    @include tablet {
      margin-bottom: 32px;
    }
  }

  &__description-params {
    margin-bottom: 40px;

    @include mobile {
      margin-bottom: 32px;
    }
  }

  &__description-block-body {
    display: flex;

    @include mobile {
      flex-direction: column;
    }
  }

  &__description-text-block {
    padding-right: 24px;

    @include mobile {
      padding-right: 0;
    }
  }

  &__description-text {
    line-height: 20px;
    margin-bottom: 20px;
  }

  &__description-text-title {
    text-transform: uppercase;
    color: $gray;
    margin-bottom: 4px;
  }

  &__description-images {
    flex-shrink: 0;
    width: 565px;
    height: 450px;

    @include tablet {
      width: 375px;
      height: 370px;
    }

    @include mobile {
      width: 100%;
      height: 340px;
      margin-top: 32px;
    }
  }

  &__video-button {
    margin-top: 40px;

    @include mobile {
      button {
        width: 100%;
      }
    }
  }

  &__comment-block {
    display: flex;
    align-items: flex-start;
    margin-top: 40px;

    @include mobile {
      flex-direction: column;
    }
  }

  &__comment-person {
    flex-shrink: 0;
    width: 125px;
    margin-right: 45px;

    @include mobile {
      width: auto;
      order: 2;
      margin-right: 0;
      margin-left: 22px;
    }
  }

  &__comment-person-name {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
  }

  &__comment-block-person-position {
    line-height: 20px;
  }

  &__comment-block-about {
    display: flex;
    align-items: flex-start;

    @include mobile {
      align-items: center;
    }
  }

  &__comment-quotes {
    flex-shrink: 0;
  }

  &__comment-text {
    padding-left: 25px;

    @include mobile {
      padding-left: 0;
      padding-top: 20px;
    }
  }
}
</style>
